import { faker } from '@faker-js/faker';

import type { ChangeRetirementDatePostResponse } from '../types/ChangeRetirementDatePostResponse';

export function createChangeRetirementDatePostResponse(
  data: NonNullable<Partial<ChangeRetirementDatePostResponse>> = {}
): NonNullable<ChangeRetirementDatePostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
